// src/components/EditProfileForm.jsx
import React from "react";
import Avatar from "./Avatar";

// Roles de tu app (inline, sin archivo extra)
const ROLES = ["Administrador", "Ventas", "Compras", "Contabilidad"];

export default function EditProfileForm({
  initial,
  onSubmit,
  onCancel,
  saving,
}) {
  const [form, setForm] = React.useState(initial);
  const [preview, setPreview] = React.useState(null);
  //eslint-disable-next-line
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    setForm(initial);
  }, [initial]);

  const change = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    if (e.target.name === "role") setError("");
  };

  const pick = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setForm((f) => ({ ...f, photoFile: file }));
    const r = new FileReader();
    r.onload = () => setPreview(r.result);
    r.readAsDataURL(file);
  };

  const submit = (e) => {
    e.preventDefault();
    if (!ROLES.includes(form.role)) {
      setError("Selecciona un rol válido.");
      return;
    }
    onSubmit(form);
  };

  return (
    <form onSubmit={submit} style={{ display: "grid", gap: 14 }}>
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        {preview ? (
          <img
            src={preview}
            alt=""
            style={{
              width: 96,
              height: 96,
              borderRadius: 12,
              objectFit: "cover",
              border: "1px solid #E5E7EB",
            }}
          />
        ) : (
          <Avatar userId={initial.userId} size={96} />
        )}
        <label className="btn-secondary" style={{ cursor: "pointer" }}>
          Cambiar imagen
          <input
            type="file"
            accept="image/*"
            onChange={pick}
            style={{ display: "none" }}
          />
        </label>
      </div>

      <label style={{ display: "grid", gap: 6 }}>
        <span style={{ fontSize: 14, color: "#374151" }}>Nombre</span>
        <input
          name="name"
          value={form.name}
          onChange={change}
          required
          style={{
            height: 38,
            padding: "8px 10px",
            border: "1px solid #E5E7EB",
            borderRadius: 10,
          }}
        />
      </label>

      <label style={{ display: "grid", gap: 6 }}>
        <span style={{ fontSize: 14, color: "#374151" }}>Correo</span>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={change}
          required
          style={{
            height: 38,
            padding: "8px 10px",
            border: "1px solid #E5E7EB",
            borderRadius: 10,
          }}
        />
      </label>

      {/*
      <label style={{ display: "grid", gap: 6 }}>
        <span style={{ fontSize: 14, color: "#374151" }}>Rol</span>
        <select
          name="role"
          value={form.role}
          onChange={change}
          style={{
            height: 38,
            padding: "8px 10px",
            border: "1px solid #E5E7EB",
            borderRadius: 10,
            background: "#fff",
          }}
        >
          {ROLES.map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
        {error && (
          <span style={{ color: "#DC2626", fontSize: 12, marginTop: 4 }}>
            {error}
          </span>
        )}
      </label>
      */}

      <div
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "flex-end",
          marginTop: 8,
        }}
      >
        <button
          type="button"
          className="btn-secondary"
          onClick={onCancel}
          disabled={saving}
        >
          Cancelar
        </button>
        <button type="submit" className="new-task-button" disabled={saving}>
          {saving ? "Guardando..." : "Guardar cambios"}
        </button>
      </div>
    </form>
  );
}
